import { PageContainer } from '@ant-design/pro-components';
import { Flex } from 'antd';
import WorkplaceContentCreation from '../components/WorkplaceContentCreation';
import WorkplaceTraceSummary from '../components/WorkplaceTraceSummary';

const Workplace = () => {
  return (
    <PageContainer>
      <Flex vertical gap="large">
        <WorkplaceTraceSummary />
        <WorkplaceContentCreation />
      </Flex>
    </PageContainer>
  );
};

export default Workplace;
